import { useQuery } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';
import type { IUninstallStats } from '@/interfaces';

export const useRequestGetUninstallStats = () => {
	const { isLoading, data, error } = useQuery({
		queryKey: [routes.api.pushUninstalls.base],
		queryFn: () =>
			apiClient
				.get<IUninstallStats>(routes.api.pushUninstalls.base)
				.then(handleApiResponse),
		staleTime: 60_000,
	});

	return {
		isLoading,
		stats: data,
		error,
	};
};
